import {RFValue} from 'react-native-responsive-fontsize';
import styled from 'styled-components/native';

export const Container = styled.View`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;

  justify-content: center;
  align-items: center;
  z-index: 999;
  /* garante sobreposição no Android */
  elevation: 999;
  /* opcional: backdrop levinho */
  /* background-color: rgba(0,0,0,0.05); */
`;

export const LoadingContainer = styled.View`
  width: ${RFValue(50)}px;
  height: ${RFValue(50)}px;
  justify-content: center;
  align-items: center;
  border-radius: ${RFValue(12)}px;
  background: ${({theme}) => theme.colors.text_dark};
`;
